/**
 * The "I want to" cards under the release card: one for each thing a reader
 * came to do. Each card has a bold title and a short summary.
 */

/** One card. */
export interface HomeCard {
  readonly title: string
  /** One line that says where the card leads. */
  readonly summary: string
  readonly href: string
}

/**
 * The home cards, in display order. The first card leads into the app, so its
 * address is the one the page already chose for the channel shown. The other
 * two lead to the docs, which ship inside the release, so they name that
 * release's own content-address origin (`releaseOrigin`, ending in a slash)
 * and never the shared `latest` origin. The page draws the cards only after the
 * signed list verifies.
 */
export const buildHomeCards = (openAppUrl: string, releaseOrigin: string): readonly HomeCard[] => [
  {
    title: 'Bridge',
    summary: 'Move tokens to or from PulseChain.',
    href: openAppUrl,
  },
  {
    title: 'Build',
    summary: 'Add bridge routes to your app.',
    href: `${releaseOrigin}docs/sdk/`,
  },
  {
    title: 'Learn',
    summary: 'Send a transfer and track it.',
    href: `${releaseOrigin}docs/guide/`,
  },
]
